<template>
    <template v-if="visible">
        <Nights v-if="isSembonusUser" />
        <Join v-else :isAuthorized="isAuthorized" :isEligible="isEligible" />
    </template>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue';
    import { SemboUser } from '@/api/Members/members.interfaces';
    import { useStore } from '@/store';
    import Nights from './Nights/Nights.vue';
    import Join from './Join/Join.vue';

    export default defineComponent({
        name: 'Sembonus',
        components: { Nights, Join },
        setup() {
            const store = useStore();

            const visible = computed<boolean>(() => store.getters['cart/hasHotelProducts']);

            const user = computed<SemboUser | null>(() => store.getters['auth/getUser']);

            const isAuthorized = computed<boolean>(() => !!user.value);
            const isEligible = computed(() => user.value?.member?.canBeSembonusUser ?? false);
            const isSembonusUser = computed(
                () => user.value?.member?.isSembonusUser && isEligible.value
            );

            return { isAuthorized, isSembonusUser, isEligible, visible };
        },
    });
</script>
